(() => {
  const phoneNumbers = document.querySelectorAll('.js-phone');
  if (!phoneNumbers.length) return;

  const { phone } = EvoXLayer().session.default_branch;

  phoneNumbers.forEach((phoneNumber) => {
    phoneNumber.href = `tel:${phone}`;
    phoneNumber.textContent = phone;
  });
})();

(() => {
  const quicklists = document.querySelector('.vuequicklistdropdown_elem');
  const quicklistscontainer = document.querySelector('.topbar__links__quicklists');
  if (!quicklists || !quicklistscontainer) return;

  quicklistscontainer.appendChild(quicklists);
})();
